import { PUBLIC_CARRIER_COOKIE } from 'core/domain/Carrier'
import { cookieClient, type CookieClient } from 'core/infra/cookie'
import { ShipperGuideClient } from 'core/infra/http/ShipperGuideClient'

import { ProposalRepository } from '../infra/ProposalRepository'

export type GetProposalFactoryDependencies = {
  repository: ProposalRepository
  cookie: CookieClient
}

export function getProposalFactory({ repository, cookie }: GetProposalFactoryDependencies) {
  return async function getProposalById(
    id: string,
    queryParams: string | null,
    config?: { signal?: AbortSignal }
  ) {
    const proposal = await repository.getProposalById(id, queryParams, config)

    cookie.setCookie(PUBLIC_CARRIER_COOKIE, proposal.carrier)

    return proposal
  }
}

export function getProposal(
  id: string,
  queryParams: string | null,
  config?: { signal?: AbortSignal }
) {
  const httpClient = new ShipperGuideClient()
  const repository = new ProposalRepository({ httpClient })
  const newGetProposal = getProposalFactory({ repository, cookie: cookieClient })
  return newGetProposal(id, queryParams, config)
}
